import { render, staticRenderFns } from "./M2hWatchOnTheGo.vue?vue&type=template&id=178f7e00&scoped=true&"
import script from "./M2hWatchOnTheGo.vue?vue&type=script&lang=js&"
export * from "./M2hWatchOnTheGo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178f7e00",
  null
  
)

export default component.exports